import { render, staticRenderFns } from "./StoresFilters.vue?vue&type=template&id=04778de1"
import script from "./StoresFilters.vue?vue&type=script&lang=js"
export * from "./StoresFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports